module.exports = __webpack_public_path__ + "static/media/scary_3.8a00251d.jpg";